import React from 'react';
import styled from 'styled-components';

import { ColorStatus } from './ColorStatus';

interface FlightStatusProps {
  displayName?: string;
  flightNumber?: string;
  status?: string;
  divertedAirportDisplayCode?: string;
}

const FlightHeader = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 5px;
`;

const CarrierText = styled.div`
  display: inline-block;
  align-self: center;
  font-weight: bold;
  font-size: 20pt;
  margin: 10px 10px 0 0;
  line-height: 20pt;
  width: auto;
`;

/**
 * FlightStatus component to display flight status details.
 * @param {FlightStatusProps} props - The props for the component.
 * @returns {JSX.Element} The FlightStatus component.
 */
export const FlightStatus: React.FC<FlightStatusProps> = ({
  displayName = '',
  flightNumber = '',
  status = '',
  divertedAirportDisplayCode = '',
}) => {
  return (
    <>
      <FlightHeader>
        <CarrierText>
          {displayName} {flightNumber} Flight Details
        </CarrierText>
        <ColorStatus
          status={status}
          divertedAirportDisplayCode={divertedAirportDisplayCode}
        />
      </FlightHeader>
    </>
  );
};